export default __webpack_public_path__ + "static/media/MACEDONIA.fc020a0a.jpeg";